import React from 'react';

import { useLocalizedStrings } from 'app/localization/Context';

// import { ReactComponent as IconLoading } from 'images/connection/connecting-white.svg';
import CustomLoadingIcon from 'images/connection/CustomLoadingIcon';

import './Waiting.scss'

function Waiting(props) {
    const s = useLocalizedStrings();

    return (
        <div className="register-home-waiting-for-accept">
            {/* <IconLoading className="icon" /> */}
            <CustomLoadingIcon className="icon" color="white" />
            <div className="label">{s.waitingForAccept}</div>
            <div className="detail-label">{s.waitingForAcceptInfo}</div>
            <div />
            <div onClick={props.clearPhoneNumber} className="try">{s.tryAnotherHub}</div>
        </div>
    )
}

export default Waiting;